import React from 'react'
import moment from 'moment'
import { component_tool } from '../../../../tool'
import LookForm from './lookForm';

let { WizModal, WizInput } = component_tool

let componentName = 'siteOrder'

export const columns = (record = {}) => {
  const cols = [
    {
      title: '预约编号',
      name: 'number',
      dataIndex: 'number',
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true
      }
    },
    {
      title: '场地名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true
      }
    },
    {
      title: '场地编号',
      name: 'code',
      dataIndex: 'code',
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true
      }
    },
    {
      title: '预约日期',
      name: 'date',
      dataIndex: 'date',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      },
      tableItem: {
        type: 'custom',
        render: (text, record) => {
          let { start, end } = record
          let value = start + ' ~ ' + end
          return <div >{value}</div>
        }
      },
      formItem: {
        type: 'custom',
        render: (record = {}) => {
          let { start, end } = record
          let value = start + ' ~ ' + end
          return <WizInput value={value} disabled={true} />
        }
      }
    },
    {
      title: '预约人',
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {},
      formItem: {
        disabled: true
      }
    },
    {
      title: '联系电话',
      name: 'orderMobile',
      dataIndex: 'orderMobile',
      tableItem: {},
      formItem: {
        disabled: true
      }
    },
    {
      title: '使用类型',
      name: 'useType',
      dict: [
        { code: 0, codeName: '新产品培训' },
        { code: 1, codeName: '实操培训' },
        { code: 2, codeName: '岗位培训' },
        { code: 3, codeName: '区域会议' },
        { code: 4, codeName: '岗位认证' },
        { code: 5, codeName: '其他' },
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        disabled: true
      }
    },
    {
      title: '申请状态',
      name: 'status',
      dataIndex: 'status',
      dict: [
        { code: 0, codeName: '提交审核中' },
        { code: 1, codeName: '审核成功' },
        { code: 2, codeName: '审核失败' },
        { code: 3, codeName: '取消使用' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        disabled: true
      }
    }
  ]
  if(record.status === 3) {
    cols.push({
      title: '取消原因',
      name: 'cancelRemark',
      dataIndex: 'cancelRemark',
      formItem: {
        type: 'custom',
        render: (record) => {
          let value = record.cancelRemark || ''
          return <WizInput value={value} disabled={true} />
        }
      },
    })  
  }
  return cols
}
const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns: columns(),
      searchBarProps: {
        dataFormat: (params) => {
          let value = Object.assign({}, params)
          if (value.date && value.date.length) {
            value.startDate = moment(value.date[0]).format('YYYY-MM-DD')
            value.endDate = moment(value.date[1]).format('YYYY-MM-DD')
          }
          // delete value.date
          return value
        },
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['look', 'cancelEmploy'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "查看",
                diy: (e) => {
                  return (
                    <LookForm
                      key={'siteOrder' + e.record.id}
                      {...e}
                    />
                  )
                },
                footer:null,
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          }
        },
        {
          key: 'cancelEmploy',
          custom: true,
          params: { children: '取消使用'},
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'cancel',
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let params = {
                id: record.id,
                cancelRemark: ''
              }
              WizModal.confirm({
                title: '取消原因',
                content: (
                  <div>
                    <WizInput.TextArea
                      style={{ height: 100, marginTop: 20, marginBottom: 20 }}
                      placeholder='取消原因最多输入100个字'
                      maxLength={100}
                      onChange={(e) => { params.cancelRemark = e.target.value }}
                    />
                  </div>
                ),
                onOk: () => {
                  callback && callback(params)
                },
                onCancel() {
                }
              })
              return null
            }
          },
          recordChangeParams: ({ record, rows }) => {
            let disabled = (record.status !== 0 && record.status !== 1) || record['isOverdue'] === 1
            return { disabled }
          }
        }
      ]
    }
  }
}

const apis = (self) => {
  let orderPersonId = self && self._userInfo() && self._userInfo().personId
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage_siteOrderRecord`,
        apiParams: { orderPersonId: orderPersonId || '-1' }
      }
    },
    cancel: {
      path: `${componentName}/cancel`,
      payload: {
        key: `${componentName}@cancel`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export_siteOrderRecord`,
        apiParams: { orderPersonId: orderPersonId || '-1' }
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  let { self, ...rest } = args
  return {
    apis: apis(self),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...rest
  }
}

export { reduxTemplateCofig, templateConfig }